import React from "react";
import "react-datepicker/dist/react-datepicker.css";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { AuthProvider } from "./routes/authProvider";
import { store } from "./store/store";
import "./components/utils/googleAnalyticsUtils";
import "./components/utils/mixPanelUtils";
import { setupGlobalAxiosInterceptor } from "./utils/axiosInterceptor";

// Install the global 401 interceptor before anything renders.
setupGlobalAxiosInterceptor();

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);

root.render(
	<Provider store={store}>
		<BrowserRouter>
			<AuthProvider>
				<App />
			</AuthProvider>
		</BrowserRouter>
	</Provider>,
);
reportWebVitals();
